/**
 * Decides whether a table may offer the full-screen toggle (SYD-2437).
 *
 * The single answer `ArTableControls` gates the expand button on. Full screen
 * fixes the table's own container to the viewport, which neither layout-editor
 * preview can honour: the entity preview publishes `pageScope.source ===
 * 'preview'` from `PreviewEntityProvider`, and the form preview sets
 * `formStore.state.previewMode` from `PreviewFormMount`. In either the fixed
 * container would paint over the editor that owns the screen, so the toggle is
 * offered on real pages only.
 */

import type { PageScope } from '@/store';

export function canFullScreenTable(input: {
  pageScopeSource: PageScope['source'];
  formPreviewMode: boolean;
}): boolean {
  return input.pageScopeSource !== 'preview' && !input.formPreviewMode;
}
